import LinkWithParams from "./LinkWithParams";

export default LinkWithParams;
